import { SearchStyle } from '../../Config';
import dropdownReducer, { initialState as dropdownInitialState, } from './dropdown';
import searchPageReducer, { initialState as searchPageInitialState, } from './resultsPage';
export function getInitialState(config) {
    return config.searchStyle === SearchStyle.dropdown
        ? dropdownInitialState
        : searchPageInitialState;
}
function getReducer(config) {
    return config.searchStyle === SearchStyle.dropdown
        ? dropdownReducer
        : searchPageReducer;
}
export default getReducer;
//# sourceMappingURL=index.js.map